import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  DatePicker,
  Flex,
  Space,
  Tag,
  InputNumber,
} from "antd";
import api from "../../api";
import { useNavigate } from "react-router-dom";
import CustomHeader from "../../components/header/CustomHeader";
import { capitalize, formatDateTime } from "../../utilities/utils";
import { useToast } from "../../components/toast/toast";
import CustomModal from "../../components/modal/CustomModal";
import CustomInput from "../../components/input/CustomInput";
import { IconAlertSquareRounded } from "@tabler/icons-react";

const { RangePicker } = DatePicker;

const LotteryListPage = ({ type = "active" }) => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    keyword: "",
    draw_range: [],
  });
  const [sorter, setSorter] = useState({ field: null, order: null });
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [previewValue, setPreviewValue] = useState(0);
  const navigate = useNavigate();
  const toast = useToast();

  const fetchData = async (
    page = 1,
    limit = 10,
    sortField = sorter.field,
    sortOrder = sorter.order
  ) => {
    setLoading(true);
    const params = {
      ...filters,
      page,
      limit,
      sortBy: sortField,
      sortOrder,
      draw_from: filters.draw_range[0]?.toISOString(),
      draw_to: filters.draw_range[1]?.toISOString(),
    };
    // if (type === "active") params.is_drawing = "true";
    if (type === "active") {
      params.visibility = "public";
      params.status_in = ["upcoming", "ongoing", "drawing"];
    }
    if (type === "completed") params.status = "completed";
    if (type === "draft") params.visibility = "draft";

    // console.log("params", params);

    // params._ = Date.now();
    const res = await api.get_lottery_list(params);

    // console.log("fetchData res --->", res);
    if (res.status === 200) {
      setData(res.data.data);
      setPagination({
        ...pagination,
        current: page,
        total: res.data.pagination.total,
      });
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [filters, type]);

  const columns = [
    ...(type === "active"
      ? [
          {
            title: "",
            dataIndex: "preview_sort",
            key: "preview_sort",
            width: 60,
            render: (_, record) => (
              <Button
                type="text"
                onClick={() => {
                  setSelected(record);
                  setPreviewValue(record.preview_sort ?? 0);
                  setIsPreviewModal(true);
                }}
                style={{ fontSize: "12px" }}
              >
                {typeof record.preview_sort === "number"
                  ? record.preview_sort
                  : "+"}
              </Button>
            ),
          },
        ]
      : [
          {
            title: "№",
            key: "rowIndex",
            render: (_text, _record, idx) =>
              (pagination.current - 1) * pagination.pageSize + idx + 1,
            width: 60,
          },
        ]),
    {
      title: "Код",
      dataIndex: "ticket_prefix",
      key: "ticket_prefix",
      render: (text) => text ?? "-",
    },
    { title: "Нэр", dataIndex: "title", key: "title", sorter: true },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
      sorter: true,
      render: (text) =>
        text ? (
          <Tag
            color={
              text === "completed"
                ? "green"
                : text === "ongoing"
                ? "blue"
                : "orange"
            }
          >
            {capitalize(
              text === "completed"
                ? "дууссан"
                : text === "ongoing"
                ? "эхэлсэн"
                : "удахгүй болох"
            )}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Харагдах байдал",
      dataIndex: "visibility",
      key: "visibility",
      sorter: true,
      render: (text) =>
        text ? (
          <Tag color={text === "public" ? "green" : "default"}>
            {capitalize(text === "public" ? "нийтлэгдсэн" : "ноорог")}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Эхлэх огноо",
      dataIndex: "draw_date",
      key: "draw_date",
      sorter: true,
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "Үйлдэл",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          // onClick={() => navigate(`/lottery/${record.id}/edit`)}
          onClick={() => navigate(`/lottery/${type}/${record.id}/edit`)}
          style={{ fontSize: "12px" }}
        >
          Засах
        </Button>
      ),
    },
  ];

  const previewHandler = async () => {
    if (selected && previewValue >= 0) {
      const res = await api.update_preview_sort({
        id: selected.id,
        preview_sort: previewValue,
      });
      // console.log("preview res --->", res);
      if (res.status === 200) {
        setIsPreviewModal(false);
        fetchData();
        toast("Амжилттай", "success");
        setSelected(null);
        setPreviewValue(0);
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
    }
  };

  return (
    <>
      <Flex vertical>
        <CustomHeader
          title={
            type === "active"
              ? "Идэвхтэй сугалаа"
              : type === "completed"
              ? "Дууссан сугалаа"
              : "Draft сугалаа"
          }
        />

        <Space style={{ marginBottom: 12 }}>
          <Input
            placeholder="Нэр, ID хайх..."
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, keyword: e.target.value }))
            }
          />
          <RangePicker
            showTime
            format="YYYY-MM-DD HH:mm"
            placeholder={["Эхлэх огноо", "Дуусах огноо"]}
            onChange={(dates) =>
              setFilters((prev) => ({ ...prev, draw_range: dates || [] }))
            }
            style={{ height: "32px" }}
          />
        </Space>

        <Table
          rowKey="id"
          columns={columns}
          loading={loading}
          dataSource={data}
          pagination={pagination}
          onChange={(pagination, filters, sorterObj) => {
            const sortField = sorterObj.field;
            const sortOrder =
              sorterObj.order === "ascend"
                ? "asc"
                : sorterObj.order === "descend"
                ? "desc"
                : null;
            setSorter({ field: sortField, order: sorterObj.order });
            fetchData(
              pagination.current,
              pagination.pageSize,
              sortField,
              sortOrder
            );
          }}
        />
      </Flex>
      <CustomModal
        title={"Харагдах дараалал оноох"}
        open={isPreviewModal}
        onCancel={() => {
          setIsPreviewModal(false);
          setSelected(null);
          setPreviewValue(0);
        }}
        onOk={previewHandler}
      >
        <Flex vertical gap={"10px"}>
          <Flex
            style={{
              backgroundColor: "#fff6cc",
              padding: "15px",
              borderRadius: "4px",
            }}
            align="center"
            gap={"10px"}
          >
            <IconAlertSquareRounded
              strokeWidth={1.5}
              color="#5f5c73"
              style={{
                width: "20px",
                height: "20px",
                padding: 0,
                margin: 0,
                flexShrink: 0,
              }}
            />

            <p style={{ color: "#5f5c73", textAlign: "justify" }}>
              Хамгийн эхэнд харуулах бол{" "}
              <span style={{ color: "#000", fontWeight: 600 }}>“0”</span> гэсэн
              утга өгнө үү. Хэрэглэгчид харахдаа 0, 1, 2 гэх мэт дээшээ
              дарааллаар харах болно.
            </p>
          </Flex>
          <CustomInput
            type="inputNumber"
            value={previewValue}
            onChange={(e) => setPreviewValue(e)}
          />
        </Flex>
      </CustomModal>
    </>
  );
};

export default LotteryListPage;
